export default function ContractCMA({
  isChecked,
  handleCheckboxChange,
  handleNextButtonClick,
}) {
  return (
    <div className="container mb100 mt100">
      <div className="beckertitlename mb100 mt100">Becker CMA方案</div>

      <div className="card w-75 p-5 m-auto">
        <h5 className="card-title text-black text-center">
          Becker 方案購買須知與相關規定（請務必詳閱）
        </h5>
        <div className="br mb-5 mt-3"></div>

        <div className="card-body">
          <div className="card-text m-auto">
            <ol>
              <li>
                <div className="font-weight-bold">訂購程序、審閱期與契約成立</div>
                <ol>
                  <li>購買方案者，須填妥本訂購單資料表，完整審閱本購買須知與相關規定後，完成付費，方符合訂購程序。繳費前，請先確認購買產品內容與費用。</li>
                  <li>購買前請確認已完整審閱本購買須知與相關規定，審閱期已達五日。</li>
                  <li>購買方案者保證為完全行為能力人，或為已得法定代理人同意之限制行為能力人。</li>
                  <li>購買者於本線上報名及訂購流程中勾選「同意」並完成購買程序時，即表示已完整審閱並確認同意本契約全部條款內容，並同意以系統依其所填載之中文姓名自動產生之電子簽名（屬電子形式之姓名印記，非本人親筆簽名）作為本人簽名及用印之正式意思表示。購買者確認該電子簽名係其真意表示，並同意不得以非親筆簽名或電子形式為由否認其法律效力。系統並將依該電子簽名自動生成並成立本購買契約書，其效力與經購買者親筆簽名之書面契約相同，對雙方均具法律拘束力。</li>
                </ol>
              </li>

              <li>
                <div className="font-weight-bold">退費、七日猶豫期與數位內容提供</div>
                <ol>
                  <li>本商品屬於行政院公告之「通訊交易解除權合理例外情事適用準則」第 2 條可排除消費者保護法第 19 條七日解除權之合理例外情事者。</li>
                  <li>惟若商品未經領取、未開始參加課程、且未登入任何產品內含學習帳號時，購買後七日猶豫期內得要求退費；若已取得諮詢者，退費時需扣除每階段 1,000 元諮詢費。</li>
                  <li>本人知悉並同意，本商品屬非以有形媒介提供之數位內容及／或一經提供即為完成之線上服務；一經帳號開通、登入、教材領取或課程內容提供，即排除消保法第 19 條七日解除權之適用。</li>
                  <li>除可歸責於 Becker Taiwan（捷進）或依法不得排除之情形外，教材一經領取、帳號開通或登入使用後，學員不得任意要求退費或暫停效期。</li>
                  <li>學員之個人教材軟體帳號經首次登入後，教材恕不退費，亦不得要求暫停效期。</li>
                </ol>
              </li>

              <li>
                <div className="font-weight-bold">軟體帳號、使用權限與帳號安全</div>
                <ol>
                  <li>美國管理會計師 Becker CMA Exam Review 系列教材為美國進口原版教材與軟體，限購買者個人使用，不得轉贈、轉讓及分享。</li>
                  <li>美國管理會計師系列 Becker CMA Exam Review 與 Becker CMA Exam Final Review 使用權限效期，於軟體購買當日起算後之二十四個月後終止。（Your Becker CMA Exam Review license will expire 24 months from the date of purchase.）</li>
                  <li>學員領取帳號後，應妥善保管其登入密碼，確保不為他人得知。利用學員帳號密碼登入學習帳號，將推定為學員本人之行為。</li>
                  <li>因非可歸責於 Becker Taiwan（捷進）之事由導致登入密碼外洩時，學員應儘速通知；Becker Taiwan（捷進）除提供必要協助外，不負任何法律上責任。</li>
                  <li>為提升服務品質及確保學員正確使用本教材，Becker Professional Education 與 Becker Taiwan（捷進）將蒐集、處理並分析系列產品使用帳號之軟體登錄時間、網路位址（IP address）等相關資訊。在任何情況下，系統若發現有多人登錄同一帳號情況，Becker Taiwan（捷進）有權中止該帳號之軟體權限。</li>
                </ol>
              </li>

              <li>
                <div className="font-weight-bold">教材、教科書與原廠供貨</div>
                <ol>
                  <li>教材（軟體登入權限）將於購買者清款當日提供。</li>
                  <li>購買自修方案者，方案無包含紙本教科書。</li>
                  <li>2025 年 1 月 1 日起，所有方案提供電子教科書，不包含紙本教科書。因個人筆記習慣須加購教科書者，每本需酌收加購費用，加購價格依美國 Becker 規定之定價加上國際運費。</li>
                  <li>若遇書籍取用完畢，需等待國際郵務寄達台灣，無法指定取書時間。</li>
                  <li>賣方保留任何因賣方代理原廠停產因素而停止供貨的權利，賣方亦保留任何因賣方代理原廠更改貨品規格而更改之權利，並對此不負擔責任。</li>
                </ol>
              </li>

              <li>
                <div className="font-weight-bold">聯繫信箱與通知</div>
                <ol>
                  <li>學員資料表 E-mail 信箱資訊，有效期限必須達二十四個月以上。購買後請自行定期收信，本軟體服務及一切相關資訊將以該 E-mail 信箱為聯繫方式。</li>
                  <li>若因學員未定期收信導致權益受影響，學員應自負其責。</li>
                </ol>
              </li>

              <li>
                <div className="font-weight-bold">使用設備與連線需求</div>
                <ol>
                  <li>
                    使用本服務應具備下列軟硬體設備基本規格及要求：
                    <ul>
                      <li>Windows PC/NB：Windows 7 以上</li>
                      <li>Apple PC/NB：macOS 10 以上</li>
                      <li>Apple 行動裝置：iOS 13.0 以上</li>
                      <li>Android 行動裝置：Android 8.0 以上</li>
                      <li>行動裝置限定使用 APP 版觀看課程。</li>
                      <li>連線需求：寬頻網路下載速度 20Mbps 以上。</li>
                    </ul>
                  </li>
                  <li>不建議使用無線、社區型、有線電視台網路、公共免費網路，可能造成無法正常驗證登入或個人帳號密碼資料外洩。</li>
                  <li>其餘未列示之軟硬體或系統，恕不保證其觀看學習品質。</li>
                </ol>
              </li>

              <li>
                <div className="font-weight-bold">中文課程與在地加值服務</div>
                <ol>
                  <li>Becker Taiwan（捷進）各項產品說明與限制如下。各方案可能包含之中文課程、線上發問系統等在地中文加值服務，其使用有效期限與軟體效期一致。</li>
                  <li>中文課程研發目的在幫助考生加速通過考試，故學員使用或參加中文課程時間點為通過考試之前。</li>
                  <li>學員之軟體使用效期結束，或學員通過全科考試時，若未使用完畢加值服務之各類型課程時數，剩餘時數等同失效，不得異議。</li>
                  <li>直播、線上隨選隨看及雲端課程中，不得針對課程內容進行任何錄音、錄影等側錄行為。</li>
                  <li>購買「無」中文課程產品或自修方案者，不得要求索取中文加值服務或中文課程之各項研習講義、文件資料。</li>
                  <li>全系列各方案可能內含之中文課程與服務，Becker Taiwan（捷進）保有開課時間、雲端影片開放時間、課程提供時間點及內容範圍之決定權，依各期實際開課公告或課程影片上架公告認定，學員不得異議。</li>
                  <li>中文雲端課程係透過第三方教學影音平台提供。若因該第三方平台之系統維護、服務中斷、連線異常、平台功能調整或其他非可歸責於 Becker Taiwan（捷進）之事由，致學員暫時無法觀看或使用課程，Becker Taiwan（捷進）將提供必要協助並協調恢復服務，惟不負因此所生之損害賠償責任。</li>
                </ol>
              </li>

              <li>
                <div className="font-weight-bold">含中文課程方案之中文課程使用規範</div>
                <ol>
                  <li>含中文課程之方案，學員可以所持時數額度，選擇以直播、線上隨選隨看型式使用，依逐次使用時數扣除額度，使用後不得要求變更、轉讓以及重複行使權益。</li>
                  <li>含中文課程之方案學員得免費使用之中文課程總時數額度為軟體有效期限內任一期 Part 1 與 Part 2 中文課程表定時數，加上額外一倍小時補課複習時數。以單期兩科共 60 小時為例，補課複習時數為額外 60 小時。</li>
                  <li>含中文課程之方案學員選擇直播課程者，得於軟體效期內選擇一期之該科直播課程，於預約後完整參加。</li>
                  <li>選擇直播課程者若有缺課情況，缺席課程以線上隨選隨看方式進行補課，線上隨選隨看補課時數與直播缺席時數相同，不得要求另增加時數。</li>
                  <li>Becker Taiwan（捷進）保有直播課程開課日期之決定權，依各期實際開課公告認定，學員不得異議。</li>
                </ol>
              </li>

              <li>
                <div className="font-weight-bold">雲端課程點數與加購方式</div>
                <ol>
                  <li>學員單科選擇雲端型式，可於軟體效期內隨時使用。每次申請並使用觀看點數為計算憑證，由學員使用時數額度中扣除。每一點數代表三小時上課時數。</li>
                  <li>
                    學員購買方案含中文課程者，當發生免費時數額度用罄情況，於軟體有效效期內，得以單堂三小時為單位加購使用額度：
                    <ul>
                      <li>曾購買全科方案者，單堂加購金額為台幣一千五百元整。</li>
                      <li>曾購買非全科方案者，單堂加購金額為台幣兩千五百元整。</li>
                    </ul>
                  </li>
                </ol>
              </li>

              <li>
                <div className="font-weight-bold">諮詢服務、預約與服務調整</div>
                <ol>
                  <li>Becker Taiwan（捷進）保有各項線上／電話／通訊軟體諮詢服務、雲端流量分配及教室座位分配之決定權。</li>
                  <li>學員欲使用上開諮詢服務或加值服務，均須提前來電、來信或來訊預約，以確認服務團隊、辦公室與教室空間之服務狀態與起迄時間。</li>
                  <li>配合中華民國各級政府單位規定，遇天災、疫情、緊急事件或其他不可抗力因素，致 Becker Taiwan（捷進）提供之線上／電話／通訊軟體諮詢服務受到影響時，Becker Taiwan（捷進）將依實際情形調整服務提供方式、服務時間或暫停受影響之服務。</li>
                  <li>以上中文課程項目、加值服務與相關內容，Becker Taiwan（捷進）保留變更、終止、修改及解釋之權利。</li>
                </ol>
              </li>

              <li>
                <div className="font-weight-bold">報考資格與官方審查</div>
                <ol>
                  <li>購買者之報考資格應以考試指定之認證機構以及報名審查官方機構出具之審查結果為準。</li>
                </ol>
              </li>

              <li>
                <div className="font-weight-bold">個人資料保護與隱私權聲明</div>
                <ol>
                  <li>Becker Taiwan（捷進）基於本訂購單履約之目的，蒐集、處理並利用您的個人資料。本公司將依個人資料保護法第 8 條第 1 項之要求，向您告知以下事項。</li>
                  <li>蒐集目的：依照 101 年 10 月 1 日修正之個人資料保護法之特定目的及個人資料之類別，040 行銷、069 契約、類似契約或其他法律關係事務、090 消費者客戶管理與服務、157 調查、統計與研究分析、181 其他經營合於營業登記項目或組織章程所定之業務、182 其他諮詢與顧問服務。</li>
                  <li>個人資料類別：C001 電子郵件、中文姓名、英文拼音全名、電話號碼。C002 金融機構帳戶號碼與姓名。C003 身分證字號。C036 是否曾訂購本公司產品、得知本公司之管道。C038 在職身分。C051 所屬或畢業學校與科系。</li>
                  <li>個人資料利用之期間、地區：本公司會於契約履行、學員服務、帳務處理、法令保存期間及爭議處理所必要期間內利用您的個人資料；利用地區包含中華民國境內及 Becker 原廠帳號開通、服務提供所必要之境外地區。</li>
                  <li>個人資料利用對象及方法：本公司將會依照您所填寫之訂購資料，確認您已完成訂購，並替您註冊帳號、寄送商品、提供學員管理、行銷活動等服務。並將分析您提供之類別 C036、C038、C051 等資訊，以增進本公司之服務。除為履行本契約、開通 Becker 原廠帳號、寄送商品、金流／物流／系統服務所必要，或依法令要求外，在未經您的同意下，我們不會任意將您的個人資料提供給第三人或作不當利用。</li>
                  <li>如您所提供之個人資料不正確或不完整，可能將無法完整履行訂購單內容。</li>
                  <li>您得行使個資法第 3 條所賦予之相關權利，如您欲行使該權利請來信 service@beckertw.com。</li>
                </ol>
              </li>

              <li>
                <div className="font-weight-bold">付費購買與匯款資訊</div>
                <ol>
                  <li>
                    <strong>在台購買</strong>

                    <table className="table table-bordered mt-2 mb-3">
                      <tbody>
                        <tr>
                          <th style={{ width: "30%" }}>收款人戶名</th>
                          <td>捷進顧問有限公司</td>
                        </tr>
                        <tr>
                          <th>受款銀行</th>
                          <td>華南商業銀行信維分行（代碼：008）</td>
                        </tr>
                        <tr>
                          <th>收款人帳號</th>
                          <td>149-10-010062-0</td>
                        </tr>
                        <tr>
                          <th>匯款金額</th>
                          <td>以新台幣付費，依各方案價格計算；若需快遞書籍，請加上運費。</td>
                        </tr>
                      </tbody>
                    </table>

                    <ul>
                      <li>台灣境內快遞計費方式：便利袋快遞費每箱新台幣 100 元。因快遞公司重量限制，寄送 1–2 本為一箱，寄送 3–4 本須為兩箱。</li>
                    </ul>
                  </li>

                  <li>
                    <strong>海外購買</strong>

                    <table className="table table-bordered mt-2 mb-3">
                      <tbody>
                        <tr>
                          <th style={{ width: "30%" }}>Recipient Name</th>
                          <td>Direct Line Consulting Co.</td>
                        </tr>
                        <tr>
                          <th>Account Number</th>
                          <td>149-10-010062-0</td>
                        </tr>
                        <tr>
                          <th>Bank</th>
                          <td>Hua Nan Commercial Bank Ltd.</td>
                        </tr>
                        <tr>
                          <th>Branch</th>
                          <td>Hsin-Wei Branch</td>
                        </tr>
                        <tr>
                          <th>SWIFT Code（Bank ID）</th>
                          <td>HNBKTWTP149</td>
                        </tr>
                        <tr>
                          <th>Bank Address</th>
                          <td>2F, No. 6, Xinyi Rd. Sec. 4, Da'an Dist., 106 Taipei City, Taiwan</td>
                        </tr>
                      </tbody>
                    </table>

                    <ul>
                      <li>匯款金額：以新台幣付費，依各方案價格計算；若需快遞書籍，請加上運費，並請採全額到匯。相關中轉行手續費計算方式請向您的支付銀行確認；若無法估算，請直接另附新台幣 200 元之中轉行手續費。</li>
                      <li>快遞計費方式：由美國 Becker 直接發貨，單次寄送郵資為新台幣 1,200 元。</li>
                    </ul>
                  </li>
                </ol>
              </li>

              <li>
                <div className="font-weight-bold">終止契約</div>
                <ol>
                  <li>學員如有違反強制禁止規定或公序良俗之行為，或違反本契約經限期改正仍未改正者，Becker Taiwan（捷進）得終止本契約，學員不得異議。</li>
                  <li>如學員自行或因可歸責於己之事由終止契約者，除可歸責於 Becker Taiwan（捷進）或依法不得排除之情形外，教材一經領取、帳號開通或登入使用後，學員不得任意要求退費或暫停效期。</li>
                </ol>
              </li>
            </ol>
          </div>

          <div className="text-center">
            <label>
              <input
                className="m-2"
                type="checkbox"
                value="read"
                checked={isChecked}
                onChange={handleCheckboxChange}
                required
              />
              <span>我已詳閱並且了解</span>
            </label>
            <div className="btn btn-primary m-3" onClick={handleNextButtonClick}>
              下一步
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
